import { Button, Col, Form, Input, Row, Select, message } from 'antd'
import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { showErrors } from '~/utils/helpers'
import { useCreateUserMutation } from './mutation'
import { useSoftwaresQuery } from '~/pages/query'

export const CreateUser = () => {
  const queryClient = useQueryClient()
  const { mutate, isLoading } = useCreateUserMutation()
  const { data: softwares } = useSoftwaresQuery()

  const history = useNavigate()

  const createUser = useCallback(
    (values) =>
      mutate(values, {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['users'] })
          message.success('User created successfully')
          history('/admin/users')
        },
        onError: (e) => {
          showErrors(e)
        }
      }),
    [mutate, queryClient, history]
  )

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title="Create new user"
        onBack={() => window.history.back()}
      />
      <Form layout="vertical" onFinish={createUser}>
        <Row gutter={[48, 8]}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input placeholder="Please enter name" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please enter password' }]}
            >
              <Input.Password placeholder="Please enter password" />
            </Form.Item>

            <Form.Item
              name="softwares"
              label="Softwares"
            >
              <Select
                placeholder="Please select softwares"
                mode="multiple"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const value = option?.children || ''
                  return value.toLowerCase().includes(input.toLowerCase())
                }}
                allowClear
              >
                {softwares?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: 'Please enter email' }]}
            >
              <Input type="email" placeholder="Please enter email" />
            </Form.Item>

            <Form.Item
              name="password_confirmation"
              label="Confirm password"
              rules={[
                {
                  required: true,
                  message: 'Please enter confirm password'
                },
                ({ getFieldValue }) => ({
                  validator: (rule, value) => {
                    if (
                      !value ||
                      getFieldValue('password') === value
                    ) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error("Password and Confirm password don't match")
                    )
                  }
                })
              ]}
            >
              <Input.Password placeholder="Please enter cofirm password" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Button type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}
